

























import uniqueId from 'lodash.uniqueid';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TriStateInput extends Vue {
    @Prop({ required: true }) private value!: boolean | null;

    private input: boolean | null = this.value;
    private pluginId: string = uniqueId();

    @Watch('value')
    private onValueChanged(value: boolean | null): void {
        this.input = value;
    }

    @Watch('input')
    private onInputChanged(): void {
        this.$emit('input', this.input);
    }
}
